import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import uploadData from "../services/uploadData";

const handleFetchCustomers = async ({ page, limit, params }: any) => {
  const uri = `v1/customers?page=${page}&limit=${limit}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateCustomer = async (data: any) => {
  const uri = `v1/customers`;
  const response = postData({ data, uri });
  return response;
};

const handleFetchRelated = async ({ keyword }: any) => {
  const uri = `v1/customers/search?keyword=${keyword}`;
  const response = fetchData({ uri });
  return response;
};

const handleUploadCustomers = async ({ data }: any) => {
  const uri = `v1/customers/upload`;
  const response = uploadData({ data, uri });
  return response;
};

const handleFetchTopCreditors = async ({
  page,
  limit,
  businessId = "",
  params,
}: any) => {
  const uri = `v1/customers/creditors?page=${page}&limit=${limit}&businessId=${businessId}&${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchCustomerCount = async ({ status }: any) => {
  const uri = `v1/customers/count/all?status=${status}`;
  const response = fetchData({ uri });
  return response;
};

const handleUpdateCustomer = async ({ _id, data }: any) => {
  const uri = `v1/customers/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateExternal = async ({ _id, data }: any) => {
  const uri = `v1/customers/${_id}/external`;
  const response = patchData({ data, uri });
  return response;
};

const handleExportCustomers = async () => {
  const uri = `v1/customers/export`;
  const response = fetchData({ uri });
  return response;
};

const handleSearchCustomer = async ({ account }: any) => {
  const uri = `v1/customers/search?account=${account}`;
  const response = fetchData({ uri });
  return response;
};

const handleDeleteCustomer = async (data: any) => {
  const uri = `v1/customers`;
  const response = deleteData({ data, uri });
  return response;
};

const handleFetchUniqueBusiness = async () => {
  const uri = `v1/customers/unique/businesses`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchUniqueCategories = async () => {
  const uri = `v1/customers/unique/categories`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchUniqueAnalysis = async () => {
  const uri = `v1/customers/unique/analysis`;
  const response = fetchData({ uri });
  return response;
};

export {
  handleFetchCustomers,
  handleCreateCustomer,
  handleUpdateCustomer,
  handleSearchCustomer,
  handleFetchRelated,
  handleUploadCustomers,
  handleUpdateExternal,
  handleFetchTopCreditors,
  handleExportCustomers,
  handleFetchCustomerCount,
  handleDeleteCustomer,
  handleFetchUniqueBusiness,
  handleFetchUniqueCategories,
  handleFetchUniqueAnalysis,
};
